/* eslint-disable no-case-declarations */
/* eslint-disable no-shadow */
import setActiveTab from 'root/src/client/logic/tab/actions/setActiveTab'
import getCurrentModuleId from 'root/src/client/logic/route/util/getCurrentModuleId'
import map from 'ramda/src/map'

// eslint-disable-next-line max-len
export default (endpointId, moduleId) => dispatch => map(zipModuleId => dispatch(setActiveTab(zipModuleId, endpointId)),
	[moduleId, getCurrentModuleId()])
